import {useState, useEffect} from "react";
import {
  EsgDirectionWithSegments,
  IEsgResponseFromCMS,
} from "../pages/Esg/EsgDashboard.type";

const useFetchDataEsgLayers = (apiUrlLayers: string, apiKey: string) => {
  const [layersData, setLayersData] = useState<IEsgResponseFromCMS<
    EsgDirectionWithSegments[]
  > | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const headers = new Headers({
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    });

    const layersUrl = new URL(apiUrlLayers);

    layersUrl.searchParams.set("populate", "*");

    fetch(layersUrl.href, {headers})
      .then((response) => response.json())
      .then((layersData) => {
        setLayersData(layersData);
      })
      .catch((error) => {
        setError(error);
      });
  }, [apiUrlLayers, apiKey]);
  return {layersData, error};
};

export default useFetchDataEsgLayers;
